import Vue from 'vue'
import App from './App.vue'
import vueRouter from 'vue-router'
import './assets/css/bootstrap.min.css'
import './assets/scss/app.scss';
import './assets/scss/main.scss';
import './assets/css/owl.carousel.min.css';
import './assets/css/owl.theme.css';
import './assets/css/responsive.css';
import './assets/css/vueperslides.css';
import {routes} from './routes'

Vue.use(vueRouter);
const router = new vueRouter({
    routes,
    mode: 'history',

})
Vue.config.productionTip = false
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
